module.exports = __webpack_public_path__ + "static/end-bottom-9ad4cacf260c06ea5660f9b4f0834e13.jpg";